export const loginContainerStyles = `flex flex-col`

export const loginTextStyles = `mb-3 font-semibold text-4xl text-center`

export const loginDescriptionStyles = `text-md-regular text-center mb-8`
